const pageNameKey = "filteredMissingNodesPillButton";

export const filteredMissingNodesPillButtonEn = {
  [pageNameKey]: {
    indicatorIconAltText: "Indicator Icon",
    barsIconAltText: "Bars Arrow Icon",
  },
};

export const filteredMissingNodesPillButtonPtBr = {
  [pageNameKey]: {
    indicatorIconAltText: "Ícone indicador",
    barsIconAltText: "Ícone de barra com seta",
  },
};

export const filteredMissingNodesPillButtonDe = {
  [pageNameKey]: {
    indicatorIconAltText: "Indikator-Symbol",
    barsIconAltText: "Balkenpfeil-Symbol",
  },
};

export const filteredMissingNodesPillButtonZhHans = {
  [pageNameKey]: {
    indicatorIconAltText: "指示器图标",
    barsIconAltText: "条形箭头图标",
  },
};

export const filteredMissingNodesPillButtonIt = {
  [pageNameKey]: {
    indicatorIconAltText: "Icona Indicatore",
    barsIconAltText: "Icona Freccia a Barre",
  },
};

export const filteredMissingNodesPillButtonEs = {
  [pageNameKey]: {
    indicatorIconAltText: "Icono indicador",
    barsIconAltText: "Icono de barras y flecha",
  },
};

export const filteredMissingNodesPillButtonNl = {
  [pageNameKey]: {
    barsIconAltText: "Balken-pijlpictogram",
    indicatorIconAltText: "Indicatorpictogram",
  },
};

export const filteredMissingNodesPillButtonTr = {
  [pageNameKey]: {
    barsIconAltText: "Çubuklar Ok Simgesi",
    indicatorIconAltText: "Gösterge Simgesi",
  },
};
